import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ImageRevealScroll = ({ data = {} }) => {
  const [revealed, setRevealed] = useState(false);
  const direction = data.direction || 'left';
  const overlayColor = data.overlayColor || 'bg-purple-600';

  useEffect(() => {
    const timer = setTimeout(() => setRevealed(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const getSlideDirection = () => {
    switch (direction) {
      case 'left': return { x: '-100%' };
      case 'right': return { x: '100%' };
      case 'up': return { y: '-100%' };
      case 'down': return { y: '100%' };
      default: return { x: '-100%' };
    }
  };

  return (
    <div className="relative h-full w-full overflow-hidden bg-gray-100">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: data.imageUrl 
            ? `url(${data.imageUrl})` 
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}
      />
      
      {/* Curtain Overlay */}
      <motion.div
        initial={{ x: 0, y: 0 }}
        animate={revealed ? getSlideDirection() : { x: 0, y: 0 }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
        className={`absolute inset-0 ${overlayColor}`}
      />

      {/* Content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: revealed ? 1 : 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <div className="text-white text-center px-8">
          <h3 className="text-3xl font-bold mb-2">
            {data.title || 'Revealed Content'}
          </h3>
          <p className="text-lg opacity-90">
            {data.subtitle || 'Beautiful curtain reveal effect'}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default ImageRevealScroll;

